define('modules/editor/models/property_groups/size',['require','exports','module','backbone','./base','lib/util','../../behaviours/apply_css_properties'],function(require, exports, module) {
  var Backbone = require("backbone"),
      BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "size",
    properties: ["width", "height"],
    validators: {
      width: function(attrs){
        var value = parseInt(attrs.width);
        return this.isInteger(attrs.width) && this.isNumber(value) && (value > 0);
      },
      height: function(attrs){
        var value = parseInt(attrs.height);
        return this.isInteger(attrs.height) && this.isNumber(value) && (value > 0);
      }
    }
  });

  util.mixin(module.exports, require("../../behaviours/apply_css_properties"));

});

